import { Injectable, signal } from '@angular/core';
import { LoginDataResponse } from '../../../../generated-sources/openapi/model/loginDataResponse';

const TOKEN = 'frakcio-monitoring-token';
const USER = 'frakcio-monitoring-user';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private readonly _isAuthenticated = signal<boolean>(!!localStorage.getItem(TOKEN));

  readonly isAuthenticated = this._isAuthenticated.asReadonly();

  login(token: string, user: LoginDataResponse): void {
    localStorage.setItem(TOKEN, token);
    localStorage.setItem(USER, JSON.stringify(user));
    console.log(user);
    this._isAuthenticated.set(true);
  }

  logout(): void {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(USER);
    this._isAuthenticated.set(false);
  }

  getToken(): string | null {
    return localStorage.getItem(TOKEN);
  }

  getUser(): LoginDataResponse | null {
    const user = localStorage.getItem(USER);
    return user ? JSON.parse(user) : null;
  }
}
